/**
 * Choosing between the operator's English and their Urdu.
 *
 * Meal names, city names and payment rails are rows in the database, not
 * strings in this app, so they cannot go in the dictionary: an operator adds
 * a meal after release and it has to appear in both languages. They write
 * both, and this picks one — falling back to English wherever the Urdu is
 * still blank, which is always better than an empty card.
 */

import { useCallback } from 'react';

import { useLanguage } from './LanguageProvider';

export type Localized = (english: string, urdu?: string | null) => string;

export function useLocalized(): Localized {
  const { language } = useLanguage();
  return useCallback(
    (english: string, urdu?: string | null) =>
      language === 'ur' && urdu && urdu.trim() ? urdu : english,
    [language],
  );
}
